var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequested = function SvgRequested(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12Zm3.925-6.88a1.06 1.06 0 0 0-.22-.33l-2-2a1 1 0 0 0-1.41 1.41l.29.295H8a4 4 0 0 0-4 4 1 1 0 1 0 2 0 2 2 0 0 1 2-2h.585l-.29.295a1 1 0 1 0 1.41 1.41l2-2a1 1 0 0 0 .22-1.09"
  })));
};
export default SvgRequested;